'use client';
import {
  COOKIE_AUTH_STATUS_KEY,
  ECookieAuthStatus,
  useCookieAuthStatus,
} from '@ssv-website/hooks/useCookieAuthStatus';
import { useEffect, useState } from 'react';
import { CloseIcon } from 'tdesign-icons-react';
import { Drawer, Link } from 'tdesign-react';

interface DrawerBodyProps {
  className?: string;
  cookieHref: string;
  onCancle: () => void;
  onAccept: () => void;
}

const COOKIE_POLICY_TEXT = `This Cookies Policy applies to the SSV Website available at https://en.ssv.tencent.com/case/activity/summit(the “Services”). When you use the Services, we may use cookies log files, pixel tags, web beacons, scripts, eTags, mobile device IDs, plugins, HTML5 local storage and similar files or technologies (collectively, “cookies”) to collect and store information we automatically collect about your device and use of the Services. This Cookies Policy explains what cookies are, what kind of cookies may be used in our Services and how you can manage cookies.
For more information, please refer to our `;

const CookiePopupMobileBody = ({
  className,
  cookieHref,
  onCancle,
  onAccept,
}: DrawerBodyProps) => {
  return (
    <div
      className={`relative w-full bg-white overflow-hidden hidden mobile:block ${className}`}
    >
      <CloseIcon
        className="absolute top-0 right-0 cursor-pointer text-2xl"
        onClick={onCancle}
      />
      <div className="p-4">
        <div className="text-[17px] leading-[1.5] font-500 mb-4">
          Your Cookie Prefernces
        </div>
        <p className="h-[144px] font-500 text-[12px] leading-[1.5] whitespace-pre-line break-words text-[#121C5999] overflow-y-auto">
          {COOKIE_POLICY_TEXT}
          <Link
            href={cookieHref}
            className="!text-[#121C59CC] !text-[12px] !font-600"
            underline
            target="_blank"
          >
            Cookies Policy
          </Link>
          .
        </p>
      </div>
      <div className="flex px-1 py-[10px] border-t border-solid border-[#E0E5FD] gap-3">
        <div
          className={`flex-1 w-[250px] h-[80px] leading-[80px] text-center text-[24px] font-400 bg-[url(https://cdn-digital.ssv.qq.com/upload//s2025/s-btn-bg-normal.png)]  
          bg-no-repeat bg-cover bg-[#3A8AFB] text-[#FFFFFF] hover:bg-[url(https://cdn-digital.ssv.qq.com/upload//s2025/s-btn-bg-hover.png)] active:bg-[url(https://cdn-digital.ssv.qq.com/upload//s2025/s-btn-bg-active)] mobile:w-[132px] mobile:h-[44px] mobile:leading-[44px] mobile:text-xs cursor-pointer`}
          onClick={() => {
            onAccept();
          }}
        >
          Accept
        </div>
        <div
          className={`flex-1 cursor-pointer min-w-0 w-[250px] h-[80px] leading-[80px] text-[24px] text-center font-300 bg-[linear-gradient(90deg,#FFF_0%,#FBFCFF_100%)] text-[#006DFF]  mobile:w-[132px] mobile:h-[44px] mobile:leading-[44px] mobile:text-xs opacity-90 border border-solid border-[#1A7CFF] hover:text-[#121C59] active:text-[#121C59] hover:border-[#121C59]`}
          onClick={() => {
            onCancle();
          }}
        >
          Reject
        </div>
      </div>
    </div>
  );
};

const CookiePopupPCBody = ({
  className,
  cookieHref,
  onAccept,
  onCancle,
}: DrawerBodyProps) => {
  return (
    <div
      className={`w-full bg-white overflow-hidden overflow-x-auto ${className}`}
    >
      <div className="relative pt-6 text-[#121C59] bg-white max-w-full min-w-fit">
        <CloseIcon
          className="absolute top-0 right-0 cursor-pointer text-2xl"
          onClick={onCancle}
        />
        <div className="flex justify-between items-center max-w-[1372px] gap-5 mx-auto">
          <div className="flex-shrink-0 h-full gap-4 w-[971px]">
            <div className="text-[34px] leading-[1.5] font-500 flex-shrink-0">
              Your Cookie Prefernces
            </div>
            <p className="h-[130px] font-500 text-[24px] leading-[1.5] whitespace-pre-line break-words text-[#121C5999] overflow-y-auto">
              {COOKIE_POLICY_TEXT}
              <Link
                href={cookieHref}
                className="!text-[#121C59CC] !text-[24px] !font-600"
                underline
                target="_blank"
              >
                Cookies Policy
              </Link>
              .
            </p>
          </div>
          <div className="flex-shrink-0 flex flex-col gap-3">
            <div
              className={`w-[250px] h-[80px] leading-[80px] text-center text-[24px] font-400 bg-[url(https://cdn-digital.ssv.qq.com/upload//s2025/s-btn-bg-normal.png)]  
          bg-no-repeat bg-cover bg-[#3A8AFB] text-[#FFFFFF] hover:bg-[url(https://cdn-digital.ssv.qq.com/upload//s2025/s-btn-bg-hover.png)] active:bg-[url(https://cdn-digital.ssv.qq.com/upload//s2025/s-btn-bg-active)] mobile:w-[132px] mobile:h-[44px] mobile:leading-[44px] mobile:text-xs cursor-pointer`}
              onClick={() => {
                onAccept();
              }}
            >
              Accept
            </div>
            <div
              className={`cursor-pointer min-w-0 w-[250px] h-[80px] leading-[80px] text-[24px] text-center font-300 bg-[linear-gradient(90deg,#FFF_0%,#FBFCFF_100%)] text-[#006DFF]  mobile:w-[132px] mobile:h-[44px] mobile:leading-[44px] mobile:text-xs opacity-90 border border-solid border-[#1A7CFF] hover:text-[#121C59] active:text-[#121C59] hover:border-[#121C59]`}
              onClick={() => {
                onCancle();
              }}
            >
              Reject
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export function CookieAuthPopup() {
  const [visible, setVisible] = useState(false);
  const { isOpenCookieCheck, cookieAuthStatus } = useCookieAuthStatus();
  const cookieHref =
    'https://cdn-digital.ssv.qq.com/ssv_privacy/en-cookie-policy.html';
  useEffect(() => {
    if (
      ![ECookieAuthStatus.ACCEPT, ECookieAuthStatus.REJECT].some(
        (item) => item === cookieAuthStatus
      ) &&
      isOpenCookieCheck
    ) {
      setVisible(true);
    }
  }, [isOpenCookieCheck, cookieAuthStatus]);
  const onAccept = () => {
    // 通过自定义事件派发才能出发内部监听
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: COOKIE_AUTH_STATUS_KEY,
        newValue: ECookieAuthStatus.ACCEPT,
      })
    );
    setVisible(false);
  };
  const onCancle = () => {
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: COOKIE_AUTH_STATUS_KEY,
        newValue: ECookieAuthStatus.REJECT,
      })
    );
    setVisible(false);
  };
  return (
    <Drawer
      header={false}
      footer={false}
      body={
        <>
          <CookiePopupPCBody
            onAccept={onAccept}
            onCancle={onCancle}
            cookieHref={cookieHref}
            className="mobile:hidden"
          />
          <CookiePopupMobileBody
            onAccept={onAccept}
            onCancle={onCancle}
            cookieHref={cookieHref}
            className="hidden mobile:block"
          />
        </>
      }
      placement="bottom"
      className=""
      size="auto"
      closeBtn={false}
      preventScrollThrough={true}
      visible={visible}
    ></Drawer>
  );
}
